import { render, staticRenderFns } from "./MemberPaymentRulesConfig.vue?vue&type=template&id=f666542c&scoped=true&lang=pug"
import script from "./MemberPaymentRulesConfig.vue?vue&type=script&lang=js"
export * from "./MemberPaymentRulesConfig.vue?vue&type=script&lang=js"
import style0 from "./MemberPaymentRulesConfig.vue?vue&type=style&index=0&id=f666542c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f666542c",
  null
  
)

export default component.exports